import { render } from "./tab-capsule.vue?vue&type=template&id=66b4ae5c&scoped=true&ts=true"
import script from "./tab-capsule.vue?vue&type=script&lang=ts"
export * from "./tab-capsule.vue?vue&type=script&lang=ts"

import "./tab-capsule.vue?vue&type=style&index=0&id=66b4ae5c&scoped=true&lang=stylus"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b4ae5c"]])

export default __exports__